// ##############################
// // // RegisterPage view styles
// #############################

import {
  container,
  cardTitle,
  dangerColor,
  successColor,
  primaryColor
} from "assets/jss/material-dashboard-pro-react.jsx";

import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const registerPageStyle = {
  ...customCheckboxRadioSwitch,
  cardTitle: {
    ...cardTitle,
    textAlign: "center"
  },
  container: {
    ...container,
    position: "relative",
    zIndex: "3",
    padding: "10vh 0 4vh 0"
  },
  cardSignup: {
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    marginBottom: "100px",
    padding: "40px 0px",
    marginTop: "15vh"
  },
  center: {
    textAlign: "center"
  },
  right: {
    textAlign: "right"
  },
  left: {
    textAlign: "left"
  },
  firstAndLastName: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    margin: "0 12px 2px"
  },
  form: {
    padding: "0 20px",
    position: "relative"
  },
  socialTitle: {
    fontSize: "18px"
  },
  inputAdornment: {
    marginRight: "18px",
    position: "relative"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  customFormControlClasses: {
    margin: "0 12px 12px"
  },
  checkboxLabelControl: {
    margin: "0"
  },
  checkboxLabel: {
    marginLeft: "6px",
    color: "rgba(0, 0, 0, 0.26)"
  },
  danger: {
    color: dangerColor + "!important"
  },
  successColor: {
    color: successColor
  },
  termsLink: {
    color: primaryColor
  },
  extraLabel: {
    paddingLeft: "46px",
    marginTop: "-10px",
    marginBottom: "14px",
    fontWeight: "400",
    "&:hover": {
      cursor: "pointer"
    }
  },
  amazonIcon: {
    fontSize: "27px !important",
    marginTop: "3px !important"
  }
};

export default registerPageStyle;
